export const PLAN_LIMITS = {
  professional: { ai_questions: 50,       document_uploads: 5,        ai_enabled: true  },
  business:     { ai_questions: 200,      document_uploads: 20,       ai_enabled: true  },
  // Legacy aliases for backward compat (DB may still have old values)
  starter:      { ai_questions: 50,       document_uploads: 5,        ai_enabled: true  },
  pro:          { ai_questions: 50,       document_uploads: 5,        ai_enabled: true  },
  team:         { ai_questions: 200,      document_uploads: 20,       ai_enabled: true  },
  agency:       { ai_questions: 200,      document_uploads: 20,       ai_enabled: true  },
};

export function getMonthYear() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function getResetDate() {
  const now   = new Date();
  const first = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  return first.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

/**
 * Returns current usage count without incrementing.
 */
export async function getUsageCount(supabase, userId, usageType) {
  if (!userId) return 0;
  const { data } = await supabase
    .from('ai_usage')
    .select('count')
    .eq('user_id', userId)
    .eq('usage_type', usageType)
    .eq('month_year', getMonthYear())
    .maybeSingle();
  return data?.count ?? 0;
}

/**
 * Checks if the user is within their plan limit and increments if allowed.
 * Returns { allowed, reason, current, limit }
 *   reason: 'upgrade_required' | 'limit_reached' | null
 */
export async function checkAndIncrementUsage(supabase, userId, usageType, userPlan) {
  const plan    = (userPlan || 'professional').toLowerCase();
  const limits  = PLAN_LIMITS[plan] || PLAN_LIMITS.professional;
  const limitKey = usageType === 'ai_question' ? 'ai_questions' : 'document_uploads';
  const limit   = limits[limitKey] ?? 0;

  if (limit === 0) {
    return { allowed: false, reason: 'upgrade_required', current: 0, limit: 0 };
  }

  const monthYear = getMonthYear();

  // Get current count
  const { data } = await supabase
    .from('ai_usage')
    .select('count')
    .eq('user_id', userId)
    .eq('usage_type', usageType)
    .eq('month_year', monthYear)
    .maybeSingle();

  const currentCount = data?.count ?? 0;

  if (limit !== Infinity && currentCount >= limit) {
    return { allowed: false, reason: 'limit_reached', current: currentCount, limit };
  }

  // Increment
  await supabase
    .from('ai_usage')
    .upsert(
      {
        user_id:      userId,
        usage_type:   usageType,
        month_year:   monthYear,
        count:        currentCount + 1,
        last_used_at: new Date().toISOString(),
      },
      { onConflict: 'user_id,usage_type,month_year' }
    );

  return { allowed: true, reason: null, current: currentCount + 1, limit };
}
